import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './styles/auth.css';
import App from './App';

const container = document.getElementById('root') as HTMLElement;

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Prerendered routes (see scripts/prerender.js) ship real HTML inside #root —
// hydrate those. Everything else (app/auth routes) mounts fresh.
if (container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
